<template>
    <v-container grid-list-sm text-xs-left>
        <v-toolbar flat color="white">
            <v-toolbar-title>Groups</v-toolbar-title>
            <v-divider
                    class="mx-2"
                    inset
                    vertical
            ></v-divider>
            <v-spacer></v-spacer>
            <v-btn color="primary" dark class="mb-2" @click="newGroupDialog=true">New Group</v-btn>
        </v-toolbar>
        <v-data-table
                hide-actions
                :headers="headers"
                :items="groups"
                class="elevation-1"
        >
            <template v-slot:items="props">
                <td class="text-xs-center">{{ props.item.id }}</td>
                <td class="text-xs-center">{{ props.item.name }}</td>
            </template>
        </v-data-table>

        <!-- New group -->
        <v-dialog
                v-model="newGroupDialog"
                max-width="800px"
                persistent
        >
            <v-card>
                <v-card-title>
                    <span class="headline">New group</span>
                    <v-spacer></v-spacer>
                    <v-card-actions>
                        <v-btn icon @click="newGroupDialog=false"><v-icon>mdi-close</v-icon></v-btn>
                    </v-card-actions>
                </v-card-title>


                <v-card-text>
                    <v-text-field
                            v-model="groupName"
                            label="Name"
                            :rules="[rules.required]"
                            required
                            @input="$v.groupName.$touch()"
                            @blur="$v.groupName.$touch()"
                    />
                    <v-flex class="text-xs-center">
                        <v-btn round dark color="green" @click="submit">
                            Submit
                        </v-btn>
                    </v-flex>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
    import UrlsService from "@/helpers/UrlsService";
    import TimeService from "@/helpers/TimeService";
    import APILoaderDecoratorService from "@/helpers/APILoaderDecoratorService";
    import {validationMixin,} from "vuelidate";
    import {email, maxLength, minLength, required,sameAs} from "vuelidate/lib/validators";

    export default {
        name: "GroupManagement",
        components: {},
        mixins: [validationMixin,],
        validations: {
            groupName: {required},
        },
        data() {
            return {
                rules: {
                    required: value => !!value || 'Required',
                },
                groupName: "",
                newGroupDialog: false,
                headers: [
                    {text: 'ID', align: "center", value: 'id' },
                    {text: 'Name', align: "center", value: 'name' },
                ],
                groups: [],
            }
        },

        created(){
            this.getGroups();
        },

        methods: {
            getGroups(){
                let requestUrl = {
                    url: UrlsService.groups,
                    timeout: TimeService.secondsToMillis(0),
                };
                let requestData = {

                };
                let requestObject = {
                    type: "superAdmin",
                    urlsInfo: requestUrl,
                    data: {
                        method: "get",
                        data: requestData
                    },
                };
                let messages = {
                    title: "Get groups",
                    loading: "Get groups",
                    error: "Server Error",
                };
                let options = {
                    loadingType: "fullscreen",
                    timeout: TimeService.secondsToMillis(0),
                };

                APILoaderDecoratorService.setLoader(requestObject, messages, options)
                    .then(responseSuccess => {
                        this.groups = responseSuccess;
                    });
            },
            submit(){
                this.newGroupDialog = false;
                let requestUrl = {
                    url: UrlsService.groups,
                    timeout: TimeService.secondsToMillis(0),
                };
                let requestData = {
                    name: this.groupName
                };
                let requestObject = {
                    type: "superAdmin",
                    urlsInfo: requestUrl,
                    data: {
                        data: requestData
                    },
                };
                let messages = {
                    title: "Create group",
                    loading: "Create group",
                    error: "Server Error",
                };
                let options = {
                    loadingType: "fullscreen",
                    timeout: TimeService.secondsToMillis(0),
                };

                APILoaderDecoratorService.setLoader(requestObject, messages, options)
                    .then(responseSuccess => {
                        this.getGroups();
                        this.groupName = "";
                    });
            }
        },
    };
</script>

<style lang="scss">
    tbody tr:nth-of-type(odd) {
        background-color: rgba(0, 0, 0, .05);
    }
</style>

